(() => {
  const copyWithFallback = (value) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.readOnly = true;
      textarea.setAttribute('aria-hidden', 'true');
      textarea.style.position = 'fixed';
      textarea.style.top = '0';
      textarea.style.left = '0';
      textarea.style.width = '1px';
      textarea.style.height = '1px';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const copied = document.execCommand('copy');
        textarea.remove();
        copied ? resolve() : reject(new Error('Copy command failed'));
      } catch (error) {
        textarea.remove();
        reject(error);
      }
    });
  };

  const initializeShareTrigger = (trigger) => {
    if (trigger.dataset.articleShareInitialized === 'true') return;

    trigger.dataset.articleShareInitialized = 'true';

    const shareCurrentPage = async () => {
      const shareData = {
        url: window.location.href,
        title: document.title
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
          return;
        }

        await copyWithFallback(shareData.url);
      } catch (error) {
        // A cancelled share dialog is expected and needs no visible error.
      }
    };

    trigger.addEventListener('click', shareCurrentPage);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      shareCurrentPage();
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('.js-share-trigger')) initializeShareTrigger(scope);

    scope
      .querySelectorAll?.('.js-share-trigger')
      .forEach(initializeShareTrigger);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), {
      once: true
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
